import { showError } from '../components/Messages';
import { BaseController } from './BaseController';

export default class RotinaDoSistemaController extends BaseController {
    getTitulosDaTabela = () => {
        return [
            { titulo: this.lang.codigo, orderby: 'Id', className: 'codigo' },
            { titulo: this.lang.telaDeCadastroDeRotinaDoSistema.descricao, width: '100%', orderby: 'Descricao' },
        ];
    };

    getDadosDaTabela = (item) => {
        return [item.id, item.descricao];
    };

    getObjetoDeDados = () => {
        return new Promise((resolve, reject) => {
            let state = this.getViewState();
            let item = state.itemSelecionado;

            if (!item.descricao) {
                showError(this.lang.telaDeCadastroDeRotinaDoSistema.informeADescricaoDaRotina);
                reject();
                return;
            }

            var input = {
                descricao: item.descricao,                
            };

            if (state.alterando) {
                input.id = parseInt(item.id);
            }
            resolve(input);
        });
    };
}
